import * as React from "react";

function SvgDeleteIcon(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={13.59} height={15.247} {...props}>
        <path
          d="M9.176 0H4.412a1.142 1.142 0 00-1.066 1.2v.981H.541A.58.58 0 000 2.8a.58.58 0 00.541.611h.478v10.633a1.142 1.142 0 001.066 1.2h9.57a1.142 1.142 0 001.066-1.2V3.407h.311a.594.594 0 00.557-.611.646.646 0 00-.159-.43.54.54 0 00-.4-.181h-2.788V1.2A1.142 1.142 0 009.176 0zM4.41 2.2v-.993h4.761V2.2zM2.085 14.042V3.407h9.569v10.635zm7.62-8.586a.583.583 0 00-.544.615v5.7a.548.548 0 101.089 0V6.07a.583.583 0 00-.545-.614zm-2.919 0a.583.583 0 00-.544.615v5.7a.583.583 0 00.544.615.583.583 0 00.544-.615V6.07a.583.583 0 00-.543-.614zm-2.948 0a.583.583 0 00-.544.615v5.7a.583.583 0 00.544.615.583.583 0 00.544-.615V6.07a.583.583 0 00-.543-.614z"
          fill="#3c4252"
        />
      </svg>
    </span>
  );
}

export default SvgDeleteIcon;
